<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import type { GroupedByType } from '../../../../../../Types/notification'
import NotificationBadge from './NotificationBadge.vue'

defineProps<{
  group: GroupedByType
}>()

const emit = defineEmits<{
  (e: 'click', alertTypeId: number): void
}>()

const { t } = useI18n()

const formatDate = (dateString: string): string => {
  if (!dateString) {
    return ''
  }
  const date = new Date(dateString)
  if (isNaN(date.getTime())) {
    return ''
  }
  const formattedDate = date.toLocaleDateString([], { day: '2-digit', month: '2-digit', year: 'numeric' })
  const formattedTime = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }).replace(':', 'h')
  const separator = t('common.at')

  return `${formattedDate} ${separator} ${formattedTime}`
}
</script>

<template>
  <div
    class="notification-group-item px-3 py-3 border-bottom d-flex justify-content-between align-items-center cursor-pointer"
    @click="emit('click', group.alertTypeId)"
  >
    <div class="text-truncate mr-3">
      <span class="font-weight-bold text-dark d-block text-truncate fs-13">{{ group.label }}</span>
      <small class="text-muted" v-if="group.lastCreatedAt">{{ formatDate(group.lastCreatedAt) }}</small>
    </div>
    <NotificationBadge :count="group.count" />
  </div>
</template>

<style lang="scss" scoped>
.cursor-pointer {
  cursor: pointer;
  transition: background-color 0.2s ease;
  &:hover {
    background-color: rgba(0, 0, 0, 0.03);
  }
}
</style>
